<template>
  <div>
    <h1 v-bg-typography="'h1'">{{ title }}</h1>
    <div class="page-subtitle" v-if="subtitle">{{ subtitle }}</div>
  </div>
</template>

<style scoped>
.page-subtitle {
  margin-bottom: 25px;
}
</style>

<script>
import BgTypography from "@/directives/bg-typography";

export default {
  name: "base-page-title",
  directives: {
    BgTypography,
  },
  props: {
    title: {
      type: String,
      requred: true,
    },
    subtitle: {
      type: String,
      requred: false,
      default: null,
    },
  },
};
</script>
